import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { ReactNode } from 'react';

type SettingsRowProps = {
  label: ReactNode;
  htmlFor?: string;
  children: ReactNode;
  isLast?: boolean;
  id?: string;
};

export const SettingsRow = ({ label, htmlFor, children, isLast, id }: SettingsRowProps) => (
  <Grid
    container
    id={id}
    wrap="wrap"
    sx={{ gap: '16px 32px', py: 3, borderBottom: isLast ? 0 : '1px solid', borderColor: 'mb.lineSoft' }}>
    <Typography
      component={htmlFor ? 'label' : 'span'}
      htmlFor={htmlFor}
      sx={{ flex: '0 0 160px', fontSize: 16, fontWeight: 600, pt: 1.5 }}>
      {label}
    </Typography>
    <Grid sx={{ flex: '1 1 360px', minWidth: 0 }}>{children}</Grid>
  </Grid>
);
